import { useParams, Link, useNavigate } from "react-router-dom";
import { Col, Row, Button, ButtonGroup } from 'react-bootstrap';
import { useState, useEffect, useCallback } from 'react';

import BasicSpinner from '../common/basic-spinner';
// import PreviousNext from '../common/previous-next';
// import ListView from '../common/list-view';
import PaginatedList from '../common/pagination';

import CollectionDetails from '../collection/collection-details';

import { fetchPublicCollection, fetchPublicCollectionParents, fetchPublicCollectionChildren } from '../../utils/fetch-helpers'
import { useAuth } from "../../utils/auth-provider";

//================================================================

export default function PublicCollectionPage(){

  //----------------------------------------------------------------
  //Hooks and Variables

  const navigate = useNavigate();
  const user = useAuth();
  const params = useParams();

  // const [collections, setCollections] = useState([]);
  const [collection, setCollection] = useState(null);
  const [parents, setParents] = useState(null);
  const [children, setChildren] = useState(null);

  //----------------------------------------------------------------
  // Fetching and setting Collections

  const fetchCollection = useCallback( async (collectionId, signal) => {
    setCollection(await fetchPublicCollection(collectionId));
  }, [params.collectionId]);

  //----------------------------------------------------------------

  const fetchChildren = useCallback(async (collectionId, signal) => {
    setChildren(await fetchPublicCollectionChildren(collectionId, signal));
  }, [collection]);

  //----------------------------------------------------------------

  const fetchParents = useCallback(async (collectionId, signal) => {
    setParents(await fetchPublicCollectionParents(collectionId, signal));
  }, [collection]);

  //----------------------------------------------------------------

  useEffect(() => {
    if (!collection) return;

    const abortController = new AbortController();
    const signal = abortController.signal;

    fetchChildren(collection._id, signal);
    fetchParents(collection._id, signal);

    return () => abortController.abort();
  }, [collection]);

  //----------------------------------------------------------------

  useEffect(() => {
    const abortController = new AbortController();
    const signal = abortController.signal;

    fetchCollection(params.collectionId, signal);

    return () => abortController.abort();
  }, [params.collectionId]);

  //----------------------------------------------------------------

  return(
    <>
      {/*<PreviousNext
        objects={collections}
        currentObject={collection}
        onClick={setCurrentCollection}
        basePath={'/collection'}
      />*/}

      { !collection ?
        <BasicSpinner className="mb-4 col text-center" text={'Loading...'} />
        :
        <>
          <Row className="mb-2 align-items-center">
            <Col className="h4 text-truncate" sm={9}>
              <b>{"Collection: "}</b>{collection.name || ""}
            </Col>
            { user.isAuthenticated &&
              <Col sm={3}>
                <Link to={`/dashboard/collection/${collection._id}`}>
                  <Button className="text-nowrap w-100">
                    View Your Collection
                  </Button>
                </Link>
              </Col>
            }
          </Row>

          <CollectionDetails collection={collection}/>

          <Row className='mb-2 align-items-center'>
            <Col>
              <Button
                className="w-100"
                onClick={() => navigate(-1)}
              >
                Back
              </Button>
            </Col>
            <Col>
              <Button
                className="w-100"
                onClick={() => navigate(1)}
              >
                Forward
              </Button>
            </Col>
          </Row>

          {/* Children Section */}
          { children &&
            <>
              <hr />

              <Row className="mb-3 align-items-center">
                <Col className="h4 my-0 text-start">In this Collection:</Col>
              </Row>

              { children['collections'].length > 0 &&
                <>
                  <Row className="mb-3 align-items-center">
                    <Col className="h5 m-auto text-start col">Collections</Col>
                  </Row>
                  <PaginatedList
                    list={children['collections']}
                    name="Collections"
                    type="collection"
                  />
                </>
              }

              { children['items'].length > 0 &&
                <>
                  <Row className="mb-3 align-items-center">
                    <Col className="h5 m-auto text-start col">Items</Col>
                  </Row>
                  <PaginatedList
                    list={children['items']}
                    name="Items"
                    type="item"
                  />
                </>
              }

              { children['images'].length > 0 &&
                <>
                  <Row className="mb-3 align-items-center">
                    <Col className="h5 m-auto text-start col">Images</Col>
                  </Row>
                  <PaginatedList
                    list={children['images']}
                    name="Images"
                    type="image"
                  />
                </>
              }
            </>
          }
          {/* End of Children Section */}

          {/*Parent Section*/}
          { parents && parents['collections'].length > 0 &&
            <>
              <hr />

              <Row className="mb-3 align-items-center">
                <Col className="h5 my-0 text-start">Parents</Col>
              </Row>

              <PaginatedList
                list={parents['collections']}
                name="Collections"
                type="collection"
              />
            </>
          }
          {/* End of Parent Section */}
        </>
      }
    </>
  );
}
